import { safeMutate } from "../../../utils/GeneralUtils";

export const getDataFromProps = (props) => props.data;
export const getUId = (props) => props.uId;
export const updateDataList = (data, uId, childData) => {
  return safeMutate(data, draftData => {
    draftData.forEach((choice, index) => {
      if(choice.uId === uId)
          draftData[index] = childData;
    });
  });
};
export const shouldCallParentEvent = (event, props) => props && parentEvent(event, props)
export const parentEvent = (event, props) => props[eventName(event)]
export const eventName = (event) => {
  if(event instanceof String || typeof event === "string")
    return event
  return event._reactName
}
export const propagateData = (event, uId, newData, props) => shouldCallParentEvent(event, props) && parentEvent(event, props)(event, uId, newData)
